import { SAFEA_V3_ENABLED, SAFEA_VERSION, SAFEA_VERSIONS } from '~/constants/_core/safea-v3';

const TOKEN_NAME = `${process.env.APPLICATION_ALIAS}_accessToken`;
const TOKEN_NAME_V3 = `${process.env.APPLICATION_ALIAS}_tokens`;

const _getTokenFromCookie = ($cookiz) => {
  return $cookiz.get(TOKEN_NAME, { fromRes: true }) || $cookiz.get(TOKEN_NAME, { fromRes: false }) || null;
};

export default ({ app, store }, inject) => {
  inject('token', {
    /**
     * @deprecated Use setTokenNameV3 instead
     */
    getTokenName() {
      return TOKEN_NAME;
    },
    /**
     * @deprecated Use setTokens instead
     * @param {string} token
     */
    set(token) {
      if (SAFEA_V3_ENABLED) {
        throw new Error('[Cockpit] The $token.set method cannot be used with Safe A v3');
      }

      store.commit('_core/auth/SET_TOKEN', token, { root: true });

      if (store.state._core.application.independentTabsEnabled) {
        let oldToken = null;
        if (process.client) {
          oldToken = window.localStorage.getItem(TOKEN_NAME);
        } else {
          oldToken = _getTokenFromCookie(app.$cookiz);
        }
        app.$session.set(token, token === oldToken);
      }

      if (store.state.isSSR) {
        app.$cookiz.set(TOKEN_NAME, token, {
          maxAge   : 60 * 60 * 24 * 7,
          sameSite : true,
          secure   : true,
          path     : '/'
        });
      }

      if (process.client) {
        window.localStorage.setItem(TOKEN_NAME, token);
      }
    },
    /**
     * @deprecated Use getTokens instead
     */
    get() {
      if (store.state._core.application.independentTabsEnabled) {
        if (process.server) {
          return app.$session.get() || _getTokenFromCookie(app.$cookiz);
        }

        return app.$session.get() || window.localStorage.getItem(TOKEN_NAME);
      }

      if (process.server) {
        return store.getters['_core/auth/getToken'] || _getTokenFromCookie(app.$cookiz);
      }

      return window.localStorage.getItem(TOKEN_NAME) || _getTokenFromCookie(app.$cookiz);
    },
    clear() {
      store.commit('_core/auth/SET_TOKENS_V3', {
        accessToken  : null,
        refreshToken : null,
        idToken      : null
      }, { root: true });

      if (store.state.isSSR) {
        app.$cookiz.remove(TOKEN_NAME);
      }

      if (process.client) {
        window.localStorage.removeItem(TOKEN_NAME);
        window.localStorage.removeItem(TOKEN_NAME_V3);
        app.$session.clear();
      }
    },

    // v3
    // TODO: SSR compatibility
    getTokenNameV3() {
      return TOKEN_NAME_V3;
    },
    hasTokens() {
      return !!this.getTokens();
    },
    /**
     * Session storage is cleared on browser restart
     * The last used session will be kept in localStorage
     * @returns {void}
     */
    restoreLastSession() {
      if (!store.state._core.application.independentTabsEnabled) {
        return;
      }

      const tokens = this.getTokens();
      if (tokens) {
        this.setTokens(tokens);
      }
    },
    setTokens(tokens) {
      store.commit('_core/auth/SET_TOKENS_V3', tokens, { root: true });

      if (store.state._core.application.independentTabsEnabled) {
        app.$session.setTokens(tokens);
      }

      if (SAFEA_VERSION !== SAFEA_VERSIONS.V3) {
        if (tokens.refreshToken) {
          window.localStorage.setItem(TOKEN_NAME, tokens.refreshToken);
        } else {
          window.localStorage.removeItem(TOKEN_NAME);
        }
      }
      window.localStorage.setItem(TOKEN_NAME_V3, JSON.stringify(tokens));
    },
    getTokens() {
      if (store.state._core.application.independentTabsEnabled) {
        return app.$session.getTokens() ?? JSON.parse(window.localStorage.getItem(TOKEN_NAME_V3));
      }

      return JSON.parse(window.localStorage.getItem(TOKEN_NAME_V3));
    },
    // This store is mostly to populate the v2 token
    // Do NOT use the token from the store - just call getTokens() and hasToken() as they're guaranteed to be updated
    updateStore() {
      if (store.state._core.application.independentTabsEnabled) {
        const tokens = app.$session.getTokens();
        store.commit('_core/auth/SET_TOKENS_V3', tokens, { root: true });
        // If the v2 token is desynced, this will fix it
        if (SAFEA_VERSION !== SAFEA_VERSIONS.V3) {
          app.$session.setTokens(tokens);
        }
      } else {
        const tokens = JSON.parse(window.localStorage.getItem(TOKEN_NAME_V3));
        store.commit('_core/auth/SET_TOKENS_V3', tokens, { root: true });
        // If the v2 token is desynced, this will fix it
        if (SAFEA_VERSION !== SAFEA_VERSIONS.V3) {
          app.$token.setTokens(tokens);
        }
      }
    }
  });
};
